import styled from 'styled-components';

export const Row = styled.div`
  display: flex;
`;

export const Label = styled.span`
  font-size: 14px;
  line-height: 150%;
  color: ${(props) => props.theme.colors['neutral-80']};
`;

export const Period = styled.span`
  font-size: 14px;
  line-height: 150%;
  color: ${(props) => props.theme.colors['neutral-100']};
`;

export const Action = styled.span`
  font-size: 14px;
  line-height: 150%;
  font-weight: 600;
  color: ${(props) => props.theme.colors['neutral-100']};
`;

export const Text = styled.p`
  font-size: 14px;
  line-height: 150%;
  color: ${(props) => props.theme.colors['neutral-80']};
`;

export const Highlight = styled.span<{ isBold?: boolean }>`
  color: ${(props) => props.theme.colors['neutral-100']};
  font-weight: ${(props) => (props.isBold ? 'bold' : 'normal')};
  margin-left: ${(props) => (props.isBold ? '8px' : '0')};
`;
